import { gql } from '@apollo/client';

export const postPrestamosADistancia = gql`
mutation PrestamosADistanciaRQ{
    PrestamosADistanciaRQ(input: $input)  
        @rest(type: "PrestamosADistanciaRS", path: "/api/gateway/formularios/AdhesionPortalPrestamosaDistancia",  method: "post"){
            
            resultado
            error
            stackTrace
        }
}
`